<div class="scroller-container" #scrollerContainer>
  <div class="scroller">
    <div
      class="category selected"
      *ngFor="let category of categories"
      (click)="onCategorySelect(category.id)"
    >
      <img [src]="category.categoryImage" alt="{{ category.nameEn }}" />
      @switch (languageService.currentLanguage$ | async) { @case ("En") {
      <div class="title">{{ category.nameEn }}</div>
      }@case ("Ar") {
      <div class="title title--ar">{{ category.nameAr }}</div>
      }@case ("Tr") {
      <div class="title">{{ category.nameTr }}</div>
      } }
    </div>
  </div>
</div>
